module.exports = __webpack_public_path__ + "static/media/Soul soffa 3-sits divan XL genisis lion miljö modeller 2023.f33be33b.jpg";